import { useState, useRef, useEffect, useCallback } from "react";
import BodyHeader from "./Header";
import Viewer, { ViewerRef } from "./Viewer";
import EditorContainer from "./Editor";

const Body = () => {
  const [code, setCode] = useState<string>("");
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [lastChangeHadSpace, setLastChangeHadSpace] = useState<boolean>(false);
  const editorRef = useRef<{
    save: () => Promise<void>;
    getCode: () => string;
    formatCode: () => Promise<string | undefined>;
    refresh: () => void;
  }>(null);
  const viewerRef = useRef<ViewerRef>(null);

  // Create a ref to access Editor methods
  // Add a function to handle running the code
  const handleRunCode = useCallback(async () => {
    if (editorRef.current) await editorRef.current.save();
  }, []);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "s") {
        e.preventDefault();
        handleRunCode();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handleRunCode]);

  const handleRefresh = () => {
    viewerRef.current?.setSelectedTab("Preview");
    editorRef?.current?.refresh();
    handleRunCode();
  };

  return (
    <div className="flex flex-col w-full m-auto">
      <BodyHeader
        hasChanges={hasChanges}
        onRun={handleRunCode}
        onRefresh={handleRefresh}
      />
      <div className="flex grow w-full  border-t border-border gap-4 p-4">
        <div className="flex-[1]">
          <EditorContainer
            onUpdate={setCode}
            hasChanges={hasChanges}
            onHasChanges={setHasChanges}
            editorRef={editorRef}
            setLastChangeHadSpace={setLastChangeHadSpace}
          />
        </div>
        <div className="flex-[2]">
          <Viewer
            ref={viewerRef}
            lastChangeHadSpace={lastChangeHadSpace}
            code={code}
            onRun={handleRunCode}
            onRefresh={handleRefresh}
          />
        </div>
      </div>
    </div>
  );
};

export default Body;
